import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
export const AssetMobileVersionsListTitle = /*#__PURE__*/ memo((props)=>{
    return /*#__PURE__*/ _jsx("h4", {
        className: "text-10 font-bold uppercase tracking-wider text-grey-10",
        ...props
    });
});
AssetMobileVersionsListTitle.displayName = "AssetMobileVersionsListTitle";
